import React, { useState, useEffect } from "react";
import { LiabilityReport } from "./LiabilityDashboardComponents/LiabilityReport";
import { LiabilityInfo } from "./LiabilityDashboardComponents/LiabilityInfo";
import { CreditTable } from "./LiabilityDashboardComponents/CreditTable";
import { LiabilityTable } from "./LiabilityDashboardComponents/LiabilityTable";
import { useHistory } from "react-router-dom";
import "./LiabilityDashboard.css";
import FETCH from "../../utils/fetch";
import axios from "axios";
import { setRefreshTime,setRefreshTimeAsset } from "../../redux/slices/itemsSlice";
import { useDispatch } from "react-redux";
import DEATH_API from "../../apis/death.api";
import swal from "sweetalert";
import { MODULE_API } from "../../apis";
import moment from "moment";
import { FutureLoan } from "./LiabilityDashboardComponents/FutureLoan";

export const LiabilityDashboard = () => {
  const history = useHistory();
  const [sharedState, setSharedState] = useState(false);
  const dispatch = useDispatch();
  // Function to update the shared state
  const updateSharedState = (newState) => {
    setSharedState(newState);
  };
  const [loading, setLoading] = useState(false);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});
  // state for creditTable
  const [liabilitiesCredit, setLiabilitesCredit] = useState([]);
  const [creditRows, setCreditRows] = useState([]);
  const [creditLimit, setCreditLimit] = useState([]);
  const [creditBalance, setCreditBalance] = useState([]);
  const [futureLoan, setFutureLoan] = useState([]);

  // state for Liablityinfo
  const [total, setTotal] = useState(null);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalMonthly, setTotalMonthly] = useState(0);
  const [totalAmountAll, setTotalAmountAll] = useState(0);
  const [creditCount, setCreditCount] = useState(0);
  const [totalCountAndBalance, setTotalCountAndBalance] = useState(null);
  const [totalCreditLimit, setTotalCreditLimit] = useState(null);
  const [averageInterestRate, setAverageInterestRate] = useState(null);
  const [highestARP, setHighestARP] = useState(0);
  const [highestLoan, setHighestLoan] = useState(0);
  const [highestMonthly, setHighestMonthly] = useState(0);
  const [totalMonthDiff, setTotalMonthDiff] = useState(0);
  const moduleStateMapping = {
    Student: "student",
    Auto: "auto",
    "Real Estates": "realEstate",
  };
  console.log("===>totalAmountAll===>", JSON.stringify(totalAmountAll));

  // states for Liablity Report
  const [totalLoan, setTotalLoan] = useState(0);
  const [totalBalance, setTotalBalance] = useState(0);
  const [totalBalanceUpdated, setTotalBalanceUpdated] = useState(0);
  const [syncPayload, setSyncPayload] = useState([]);
  const [clientBanks, setClientBanks] = useState(null);
  const [liabilitiesAll, setLiabilitesAll] = useState([]);
  const getAssetsList = async (page) => {
    console.log("here in cached data", cachedData, page);
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
        setLoading(true);
        let datares = await FETCH.post({
          url: "client-module-service/client-module/list",
          id: `?module=Liabilities and Credit&page=${page}&limit=10`,
          body: {},
        });
        setLoading(false);
        // setCreditRows([]);
        // setLiabilitesCredit([]);
        // setTotalLoan(0);
        // setTotalBalance(0);
        // setCreditCount(0);
        // setTotalCountAndBalance(null);
        // setTotalCreditLimit(null);
        // setAverageInterestRate(null);
        // setLiabilitesAll([]);
        // setTotalAmountAll(0);
        // setTotalMonthly(0);
        // setTotalAmount(0);
        // // for LiablityTable
        // setTotal(0);
        // if (datares && datares.pagination) {
        //   setTotal(datares.pagination.total);
        // }
        // let highestInitialLoanAmount = 0;
        // let highestIntrestRate = 0;
        // let highestMonthlyPayment = 0;
        // let totalMonthsDifference = 0;
        // let totalCards = 0;
        // let totalMonthsDifferenceLiablity = 0;
        // let totalCardsLiability = 0;
        // end for Liablity table
        if (datares && datares.records) {
          // Cache the data for the current page
          setCachedData((prevState) => ({
            ...prevState,
            [page]: datares,
          }));
          updateStateWithData(datares);

        }
        // if (datares && datares.pagination) {
        //   setTotal(datares.pagination.total);
        //   setTotalPages(Math.ceil(datares.pagination.total / datares.pagination.limit));
        // }
        // let cardsDifference=totalMonthsDifference / totalCards;
        // let liabilityDifference=totalMonthsDifferenceLiablity / totalCardsLiability;
        // let averageAge=((cardsDifference+liabilityDifference)/2).toFixed(2);
        // setTotalMonthDiff(averageAge);
        // setHighestARP(highestIntrestRate);
        // setHighestLoan(highestInitialLoanAmount);
        // setHighestMonthly(highestMonthlyPayment);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getFutureLoan = async () => {
    try {
      setLoading(true);
      let datares = await MODULE_API.fetchFutureLoans(1);
      console.log("datares fultytt",datares)
      if (datares && datares.records) {
        setFutureLoan(datares.records);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
   const getBankDetails = async () => {
        try {
          setLoading(true);
          let data = await DEATH_API.getBankDetails();
          setSyncPayload([]);
          let obj = [];
          let bankData = {};
          if (data && data.data) {
            const newArray = data.data.map((account) => {
              return {
                accountId: account.accountId,
                accountName: `${account.accountName}`,
                bankName: account.bankName,
                subType: account.subType,
                accountNumber: account.mask,
                accountTitle: `${account.accountName} ${account.mask}`,
                balance: account.balance,
              };
            });
            setClientBanks([
              ...newArray,
              {
                accountId: 1234,
                accountName: "cash",
                bankName: "devbank",
                subType: "debsubtype",
                accountNumber: 1122,
                accountTitle: "Cash",
                balance: 1111,
              },
            ]);
    
            data.data.forEach((item) => {
              if (!bankData[item.bankName]) {
                bankData[item.bankName] = [];
              }
              bankData[item.bankName].push({
                ...item,
                bankName: item.bankName,
                mask: item.mask,
              });
            });
            data.data.map((item, idx) => {
              obj.push({
                bankName: item.bankName,
                mask: item.mask,
                accessToken: item.accessToken,
              });
            });
          }
          setSyncPayload((prevState) => [...prevState, ...obj]);
          setLoading(false);
        } catch (error) {
          console.log(error);
          setLoading(false);
        }
      };
  const updateStateWithData = (datares) => {
    // Reset states
    setCreditRows([]);
    setLiabilitesCredit([]);
    setTotalLoan(0);
    setTotalBalance(0);
    setTotalBalanceUpdated(0);
    setCreditCount(0);
    setTotalCountAndBalance(null);
    setTotalCreditLimit(null);
    setAverageInterestRate(null);
    setLiabilitesAll([]);
    setTotalAmountAll(0);
    setTotalMonthly(0);
    setTotalAmount(0);
    setTotal(0);

    let highestInitialLoanAmount = 0;
    let highestInterestRate = 0;
    let highestMonthlyPayment = 0;
    let totalMonthsDifference = 0;
    let totalCards = 0;
    let totalMonthsDifferenceLiability = 0;
    let totalCardsLiability = 0;

    if (datares && datares.records) {
      setLiabilitesAll(datares.records);

      datares.records.forEach((item) => {
        if (item["subType"] === "Credit") {
          setCreditRows((prevState) => [...prevState, item]);
          setCreditCount((prevState) => prevState + 1);
          setTotalCountAndBalance(
            (prevState) => prevState + (+item["Credit Balance"] || 0)
          );
          setTotalCreditLimit(
            (prevState) => prevState + (+item["Credit Limit"] || 0)
          );
          setAverageInterestRate(
            (prevRate) => prevRate + (+item["Interest Rate (or APR%)"] || 0)
          );

          if (
            item["module"] === "Credit Card - Business" ||
            item["module"] === "Credit Card - Personal" ||
            item["module"] === "Credit - HELOC"
          ) {
            const creditCardOpenDate = item["Credit Card Open Date"]
              ? new Date(item["Credit Card Open Date"])
              : new Date();
            const currentDate = new Date();
            const diffMonths =
              (currentDate.getFullYear() - creditCardOpenDate.getFullYear()) *
                12 +
              (currentDate.getMonth() - creditCardOpenDate.getMonth());

            totalCards += 1;
            totalMonthsDifference += diffMonths;
          }

          // setTotalBalance(
          //   (prevState) => prevState + (+item["Credit Balance"] || 0)
          // );
        } else {
          const currentDate = new Date();
          if (
            item["Maturity Date"] &&
            new Date(item["Maturity Date"]) > currentDate
          ) {
            const creditCardOpenDate = item["Start Date"]
              ? new Date(item["Start Date"])
              : new Date();
            const TodaysDate = new Date();
            const diffYears =
              TodaysDate.getFullYear() - creditCardOpenDate.getFullYear();
            const diffMonths =
              diffYears * 12 +
              (TodaysDate.getMonth() - creditCardOpenDate.getMonth());

            totalCardsLiability += 1;
            totalMonthsDifferenceLiability += diffMonths;
          }
          setLiabilitesCredit((prevState) => [...prevState, item]);
          // setTotalLoan(
          //   (prevState) => prevState + (+item["Initial Loan Amount"] || 0)
          // );
        }

        const moduleKey = moduleStateMapping[item.module] || "other";

        if ((item["Loan Balance"] && item["Loan Balance"] || item["Initial Loan Amount"])> 0 && item.subType==="Liability" ) {
          setTotalAmountAll((prevState) => ({
            ...prevState,
            [moduleKey]:
              (prevState[moduleKey] || 0) +
              parseFloat(item["Loan Balance"] || +item["Initial Loan Amount"] || 0),
            other:
              moduleKey === "other"
                ? (prevState.other || 0) + parseFloat(item["Loan Balance"] || +item["Initial Loan Amount"] || 0)
                : prevState.other || 0,
          }));
        }

        if (item["Monthly Payment"] && item["Monthly Payment"] > 0) {
          setTotalMonthly(
            (prevState) => prevState + (+item["Monthly Payment"] || 0)
          );
        }

        if (
          (item["Credit Balance"] && item["Credit Balance"] > 0) ||
          ((item["Loan Balance"] && +item["Loan Balance"] || item["Initial Loan Amount"] && item["Initial Loan Amount"]) > 0)
        ) {
          setTotalAmount(
            (prevState) =>
              prevState +
              (item["Credit Balance"] || 0) +
              (+item["Loan Balance"] || item["Initial Loan Amount"] || 0)
          );
        }

        if (
          item["Initial Loan Amount"] &&
          item["Initial Loan Amount"] > highestInitialLoanAmount
        ) {
          highestInitialLoanAmount = item["Loan Balance"] || item["Initial Loan Amount"];
        }
        if (
          item["Interest Rate"] &&
          item["Interest Rate"] > highestInterestRate
        ) {
          highestInterestRate = item["Interest Rate"];
        }
        if (
          item["Interest Rate (or APR%)"] &&
          item["Interest Rate (or APR%)"] > highestInterestRate
        ) {
          highestInterestRate = item["Interest Rate (or APR%)"];
        }
        if (
          item["Monthly Payment"] &&
          +item["Monthly Payment"] > highestMonthlyPayment
        ) {
          highestMonthlyPayment = +item["Monthly Payment"];
        }
      });
    }

    if (datares && datares.pagination) {
      setTotal(datares.pagination.total);
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }

    const cardsDifference = totalMonthsDifference / totalCards;
    const liabilityDifference =
      totalMonthsDifferenceLiability / totalCardsLiability;
    const averageAge = ((cardsDifference + liabilityDifference) / 2).toFixed(2);

    setTotalMonthDiff(averageAge);
    setHighestARP(highestInterestRate);
    setHighestLoan(highestInitialLoanAmount);
    setHighestMonthly(highestMonthlyPayment);
  };
  const uniqueModules = [
    ...new Set(
      creditRows &&
        creditRows.map(
          (data) => data["Nickname of Credit"] || data["Nickname of Credit"]
        )
    ),
  ];
  // with out unique modules
  const nicknames =
    creditRows && creditRows.map((card) => card["Nickname of Credit"] || null);
  useEffect(() => {
    // this is for Bar chart
    const creditBalances =
      creditRows && creditRows.map((card) => card["Credit Balance"] || 0);
    // const creditLimits = creditRows && creditRows.map(card => {
    //   return (+card["Credit Limit"] || 0) - (+card["Credit Balance"] || 0);
    // });

    // for not showing neagtive chart
    const creditLimits =
      creditRows &&
      creditRows.map((card) => {
        const creditLimit = +card["Credit Limit"] || 0;
        const creditBalance = +card["Credit Balance"] || 0;
        const remainingCredit = creditLimit - creditBalance;
        return remainingCredit < 0 ? 0 : remainingCredit;
      });
    console.log("nicknames", nicknames, creditBalances, creditLimits);
    setCreditBalance(creditBalances);
    setCreditLimit(creditLimits);
  }, [creditRows]);
  // with unique modules
  // useEffect(() => {
  //   // this is for Bar chart
  //   let seriesData1 = [];
  //   let seriesData2 = [];
  //   const barSeries =
  //     uniqueModules &&
  //     uniqueModules.map((module) => {
  //       const creditBalanceSum =
  //         creditRows &&
  //         creditRows.reduce(
  //           (sum, data) =>
  //             data["Nickname of Credit"] === module
  //               ? sum + (+data["Credit Balance"] || 0)
  //               : sum,
  //           0
  //         );

  //       seriesData2.push(creditBalanceSum); // Push Credit Balance into the array
  //     });
  //   const barSeries1 =
  //     uniqueModules &&
  //     uniqueModules.map((module) => {
  //       const creditBalanceSum =
  //         creditRows &&
  //         creditRows.reduce(
  //           (sum, data) =>
  //             data["Nickname of Credit"] === module
  //               ? sum +
  //                 ((+data["Credit Limit"] || 0) -
  //                   (+data["Credit Balance"] || 0))
  //               : sum,
  //           0
  //         );

  //       seriesData1.push(creditBalanceSum); // Push Credit Balance into the array
  //     });
  //   setCreditBalance(seriesData2);
  //   setCreditLimit(seriesData1);
  //   console.log("barSeries", seriesData2, seriesData1, creditRows);
  //   // setMonthlyPayment(barSeries);
  // }, [creditRows]);
  useEffect(() => {
    getAssetsList(currentPage);
    if(!clientBanks){
      getBankDetails();
    }
  }, [sharedState, currentPage]);
  const getAssetsListAfterDelete = async (page) => {
    try {
      setLoading(true);
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: `?module=Liabilities and Credit&page=${page}&limit=10`,
        body: {},
      });
      setLoading(false);
      // setCreditRows([]);
      // setLiabilitesCredit([]);
      // setTotalLoan(0);
      // setTotalBalance(0);
      // setCreditCount(0);
      // setTotalCountAndBalance(null);
      // setTotalCreditLimit(null);
      // setAverageInterestRate(null);
      // setLiabilitesAll([]);
      // setTotalAmountAll(0);
      // setTotalMonthly(0);
      // setTotalAmount(0);
      // // for LiablityTable
      // setTotal(0);
      // if (datares && datares.pagination) {
      //   setTotal(datares.pagination.total);
      // }
      // let highestInitialLoanAmount = 0;
      // let highestIntrestRate = 0;
      // let highestMonthlyPayment = 0;
      // let totalMonthsDifference = 0;
      // let totalCards = 0;
      // let totalMonthsDifferenceLiablity = 0;
      // let totalCardsLiability = 0;
      // end for Liablity table
      if (datares && datares.records) {
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);

        // setLiabilitesAll(datares.records);
        // datares.records &&
        //   datares.records.map((item) => {
        //     if (item["subType"] === "Credit") {
        //       console.log("here in credit");
        //       setCreditRows((prevState) => [...prevState, item]);
        //       // for Liablity Table start
        //       setCreditCount((prevState) => prevState + 1);
        //       setTotalCountAndBalance(
        //         (prevState) => prevState + (+item["Credit Balance"] || 0)
        //       );
        //       setTotalCreditLimit(
        //         (prevState) => prevState + (+item["Credit Limit"] || 0)
        //       );
        //       setAverageInterestRate(
        //         (prevRate) =>
        //           prevRate + (+item["Interest Rate (or APR%)"] || 0)
        //       );
        //       if (
        //         item["module"] === "Credit Card - Business" ||
        //         item["module"] === "Credit Card - Personal" || item["module"] === "Credit - HELOC"
        //       ) {
        //         const creditCardOpenDate =item["Credit Card Open Date"] ? new Date(item["Credit Card Open Date"]) : new Date();
        //         // Get the current date
        //         const currentDate = new Date();
        //         // Calculate the difference in months
        //         const diffMonths =
        //           (currentDate.getFullYear() -
        //             creditCardOpenDate.getFullYear()) *
        //             12 +
        //           (currentDate.getMonth() - creditCardOpenDate.getMonth());

        //         console.log("Difference in months:", diffMonths);
        //         totalCards += 1;
        //         totalMonthsDifference += diffMonths;
        //       }
        //       setTotalBalance(
        //         (prevState) => prevState + (+item["Credit Balance"] || 0),
        //       );
        //     } else {
        //       const currentDate = new Date();
        //       if (item["Maturity Date"] && new Date(item["Maturity Date"]) > currentDate) {
        //         const creditCardOpenDate = item["Start Date"] ? new Date(item["Start Date"]) : new Date();
        //         const TodaysDate = new Date();
        //         const diffYears = TodaysDate.getFullYear() - creditCardOpenDate.getFullYear();
        //         const diffMonths = diffYears * 12 + (TodaysDate.getMonth() - creditCardOpenDate.getMonth());
        //         console.log("Difference in months liablity:", diffMonths,creditCardOpenDate);
        //         totalCardsLiability += 1;
        //         totalMonthsDifferenceLiablity += diffMonths;
        //       }
        //       setLiabilitesCredit((prevState) => [...prevState, item]);
        //       setTotalLoan(
        //         (prevState) => prevState + (+item["Initial Loan Amount"] || 0)
        //       );
        //     }

        //     // for Liablity Table state setting
        //     const moduleKey = moduleStateMapping[item.module] || "other";

        //     if (
        //       item["Initial Loan Amount"] &&
        //       item["Initial Loan Amount"] > 0
        //     ) {
        //       setTotalAmountAll((prevState) => ({
        //         ...prevState,
        //         [moduleKey]:
        //           (prevState[moduleKey] || 0) + item["Initial Loan Amount"],
        //         other:
        //           moduleKey === "other"
        //             ? (prevState.other || 0) + item["Initial Loan Amount"]
        //             : prevState.other || 0,
        //       }));
        //     }

        //     if (item["Monthly Payment"] && item["Monthly Payment"] > 0) {
        //       setTotalMonthly(
        //         (prevState) => prevState + (+item["Monthly Payment"] || 0)
        //       );
        //     }
        //     if (
        //       (item["Credit Balance"] && item["Credit Balance"] > 0) ||
        //       (item["Initial Loan Amount"] && item["Initial Loan Amount"] > 0)
        //     ) {
        //       setTotalAmount(
        //         (prevState) =>
        //           prevState +
        //           (item["Credit Balance"] || 0) +
        //           (item["Initial Loan Amount"] || 0)
        //       );
        //       // setHighestARP((prevHighestRate) => Math.max(prevHighestRate, item["Initial Loan Amount"]));
        //     }
        //     if (
        //       item["Initial Loan Amount"] &&
        //       item["Initial Loan Amount"] > highestInitialLoanAmount
        //     ) {
        //       highestInitialLoanAmount = item["Initial Loan Amount"];
        //     }
        //     if (
        //       item["Interest Rate"] &&
        //       item["Interest Rate"] > highestIntrestRate
        //     ) {
        //       highestIntrestRate = item["Interest Rate"];
        //     }
        //     if (
        //       item["Interest Rate (or APR%)"] &&
        //       item["Interest Rate (or APR%)"] > highestIntrestRate
        //     ) {
        //       highestIntrestRate = item["Interest Rate (or APR%)"];
        //     }
        //     if (
        //       item["Monthly Payment"] &&
        //       +item["Monthly Payment"] > highestMonthlyPayment
        //     ) {
        //       highestMonthlyPayment = +item["Monthly Payment"];
        //     }
        //   });
      }else{
        updateStateWithData([]);
      }
      // if (datares && datares.pagination) {
      //   setTotal(datares.pagination.total);
      //   setTotalPages(Math.ceil(datares.pagination.total / datares.pagination.limit));
      // }
      // let cardsDifference=totalMonthsDifference / totalCards;
      // let liabilityDifference=totalMonthsDifferenceLiablity / totalCardsLiability;
      // let averageAge=((cardsDifference+liabilityDifference)/2).toFixed(2);
      // setTotalMonthDiff(averageAge);
      // setHighestARP(highestIntrestRate);
      // setHighestLoan(highestInitialLoanAmount);
      // setHighestMonthly(highestMonthlyPayment);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const refreshModule = async () => {
    try {
      setLoading(true);
       if(syncPayload && syncPayload.length > 0){
        const refreshData = await DEATH_API.refreshBanksData(
              syncPayload && { accounts: syncPayload }
          );
      }
      const response = await DEATH_API.refreshLiability();
      const assetResponse = await MODULE_API.refreshAssetModule();
  
      console.log("response refresf", response);
      if (response && response.status === 200) {
        console.log("heeeeee", response.updatedAt);
        dispatch(
          setRefreshTime(
            response.updatedAt && response.updatedAt.updatedAt
              ? response.updatedAt.updatedAt
              : new Date()
          )
        );
      }
      if (
        assetResponse &&
        assetResponse.status === 200 &&
        assetResponse.updatedAt &&
        assetResponse.updatedAt
      ) {
          dispatch(setRefreshTimeAsset(assetResponse.updatedAt));
      }
      if (response && response.status === "ERROR") {
        // swal("Oops!",response.message,"error");
        swal({
          title: "Please Upgrade for a complete experience.",
          text: "Your level of subscription only allows for three Refreshes per day.",
          icon: "warning",
          type: "warning",
          buttons: {
            upgrade: {
              text: "Upgrade",
              value: "upgrade",
              visible: true,
            },
            ok: {
              text: "Ok",
              value: "ok",
              visible: true,
            },
          },
        }).then((value) => {
          console.log("Button value clicked:", value); // Debugging line to show the value
          switch (value) {
            case "upgrade":
              console.log("calling upgrade");
              updatePayment();
              break;

            case "ok":
              console.log("calling ok");
              break;

            default:
              console.log("No action taken");
              break;
          }
        });
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    console.log("calling shared state");
    setCachedData({});
    // getAssetsListAfterDelete(1);
    getAllAfterDelete();
  }, [sharedState]);
  
  const getAllAfterDelete= async()=>{
    await getAssetsListAfterDelete(1);
    await getAll();
  }

  const updatePayment = () => {
    history.push("/payment");
  };

  const getDebt = async (startDate, endDate) => {
    try {
      setLoading(true);
      setTotalBalanceUpdated(0);
      let data = await MODULE_API.getDebt(startDate, endDate);

      if (data && data.data) {
        setTotalBalanceUpdated(data.data);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getLiabilitySum = async () => {
    try {
      setLoading(true);
      setTotalLoan(0);
      let data = await MODULE_API.fetchLiabilitySum("Liability");
      if (data && data.sum) {
        setTotalLoan(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getCreditSum = async () => {
    try {
      setLoading(true);
      setTotalBalance(0);
      let data = await MODULE_API.fetchLiabilitySum("Credit");
      if (data && data.sum) {
        setTotalBalance(data.sum);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const callFilter = async (startDate, endDate) => {
    await getDebt(startDate, endDate);
  };
  const getAll = async () => {
    await getFutureLoan();
    await getLiabilitySum();
    await getCreditSum();
  }

  useEffect(() => {
    const date = moment();
    const startDate = date.startOf("month").format("YYYY-MM-DD");
    const endDate = date.endOf("month").format("YYYY-MM-DD");
    // callFilter(startDate, endDate);
    // getAll();
  }, []);

  return (
    <div className="liabilityMain">
      <div className="liabilitycreate">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "1rem",
          }}
        >
          <button
            className="addbuttonLiablity"
            onClick={() => {
              history.push("/debtPayOff");
            }}
          >
            {" "}
            + Add Debt Payoff
          </button>
          <button
            className="addbuttonLiablity"
            onClick={() => {
              history.push("/liabilities_credit_new");
            }}
          >
            {" "}
            + Add Liability
          </button>
        </div>
      </div>
      <div className="liabilityMainReport">
        <LiabilityReport
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          totalLoan={totalLoan && totalLoan}
          totalBalance={totalBalance && totalBalance}
          liabilitiesCredit={liabilitiesAll && liabilitiesAll}
          loading={loading}
          totalBalanceUpdated={totalBalanceUpdated}
        />
      </div>
      <div className="liablityInfoMain">
        <LiabilityInfo
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          total={total && total}
          totalAmount={totalAmount && totalAmount}
          totalMonthly={totalMonthly && totalMonthly}
          totalAmountAll={totalAmountAll && totalAmountAll}
          creditCount={creditCount && creditCount}
          totalCountAndBalance={totalCountAndBalance && totalCountAndBalance}
          totalCreditLimit={totalCreditLimit && totalCreditLimit}
          averageInterestRate={averageInterestRate && averageInterestRate}
          highestARP={highestARP && highestARP}
          highestLoan={highestLoan && highestLoan}
          highestMonthly={highestMonthly && highestMonthly}
          totalMonthDiff={totalMonthDiff && totalMonthDiff}
          loading={loading}
        />
      </div>
      <div className="creditMainTag">
        <CreditTable
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          creditBalance={creditBalance && creditBalance}
          creditRows={creditRows && creditRows}
          uniqueModules={nicknames && nicknames}
          creditLimit={creditLimit && creditLimit}
          liabilitiesCredit={liabilitiesCredit && liabilitiesCredit}
          loading={loading}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          refreshModule={refreshModule}
        />
      </div>
      <div className="liabilityTableCard">
      <LiabilityTable
        sharedState={sharedState}
        updateSharedState={updateSharedState}
        creditRows={creditRows && creditRows}
        loading={loading}
        totalPages={totalPages}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        refreshModule={refreshModule}
      />
    </div>
      <div className="liabilityTableCard">
        <FutureLoan
          sharedState={sharedState}
          updateSharedState={updateSharedState}
          futureLoans={futureLoan && futureLoan}
          loading={loading}
        />
      </div>
    </div>
  );
};
